import { useMemo } from 'react';
import { formatAppPermissionsDialogStrings, } from '../utilities/formatAppPermissionsDialogStrings';
export const useFormattedAppPermissionsDialogStrings = ({ appDefinition, metaOSHubResources, }) => useMemo(() => formatAppPermissionsDialogStrings({
    appDefinitionPermissions: appDefinition.devicePermissions,
    appName: appDefinition.name,
    stringResources: metaOSHubResources,
}), [appDefinition, metaOSHubResources]);
//# sourceMappingURL=useFormattedAppPermissionsDialogStrings.js.map